/**
 * Converts HTML to plain text and preserves line breaks
 * @param html - The HTML string to convert
 * @returns The plain text string
 */
export const htmlToPlainTextWithLineBreaks = (html: string): string => {
  let text = html
    .replace(/<br\s*\/?>(?![\r\n])/gi, "\n")
    .replace(/<\/(div|p)>/gi, "\n")
    .replace(/<div[^>]*>|<p[^>]*>/gi, "");
  text = text.replace(/<[^>]+>/g, "");

  // Decode HTML entities using a temporary DOM element
  // This fixes issues with special characters in text messages
  if (typeof window !== "undefined") {
    const temp = document.createElement("textarea");
    temp.innerHTML = text;
    text = temp.value;
  }

  return text.trim();
};
